import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { Button } from "./Button";

export interface JsonViewerProps {
  value: unknown;
  label?: string;
}

export function JsonViewer({ value, label = "Dados JSON" }: JsonViewerProps) {
  const [copied, setCopied] = useState(false);
  const content = JSON.stringify(value, null, 2) ?? "null";

  async function copy() {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2_000);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div className="overflow-hidden rounded-lg border bg-card text-left">
      <div className="flex items-center justify-between gap-3 border-b px-4 py-2">
        <span className="text-xs font-medium text-muted-foreground">{label}</span>
        <Button
          variant="ghost"
          size="sm"
          className="text-muted-foreground hover:bg-muted hover:text-foreground"
          onClick={() => void copy()}
          aria-label={copied ? "Conteúdo copiado" : `Copiar ${label}`}
        >
          {copied ? <Check className="size-4" aria-hidden="true" /> : <Copy className="size-4" aria-hidden="true" />}
          {copied ? "Copiado" : "Copiar"}
        </Button>
      </div>
      <pre className="max-h-96 overflow-auto bg-muted/40 p-4 text-xs leading-5 text-foreground">
        <code className="bg-transparent p-0 font-mono text-inherit">{content}</code>
      </pre>
    </div>
  );
}
